var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlCleaningServiceOutlined = function SvgHtlCleaningServiceOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.819 14.994h-4.52a.5.5 0 0 1-.49-.586.5.5 0 0 1 .131-.256 3.344 3.344 0 0 0 1.064-2.167V9.494a.5.5 0 0 1 .5-.5h2.5v-7.5a.5.5 0 0 1 1 0v7.5h2.5a.5.5 0 0 1 .5.5v2.5a3.846 3.846 0 0 1-.947 2.871.5.5 0 0 1-.344.136l-1.894-.007Zm1.671-1a3.166 3.166 0 0 0 .509-1.985V9.994h-5v2.021a3.857 3.857 0 0 1-.664 1.979h1.1a3.31 3.31 0 0 0 .591-2.016.5.5 0 0 1 .999.033 4.7 4.7 0 0 1-.426 1.983h.935a3.759 3.759 0 0 0 .523-2 .5.5 0 0 1 1 0 4.781 4.781 0 0 1-.4 2h.833Zm-7.99-1a.5.5 0 1 1 0-1h1a.5.5 0 0 1 0 1h-1Zm.5-2a.5.5 0 1 1 0-1h.5a.5.5 0 0 1 0 1H4Z"
  })));
};
export default SvgHtlCleaningServiceOutlined;